import { TypeOf } from '..'

interface IDependency<T> {
  provide: TypeOf<T>
  useValue: T
}

export class DependencyContainer {
  private _sealed: boolean = false
  private _classes: Map<TypeOf<any>, any> = new Map<TypeOf<any>, any>()

  constructor() {}

  public provideValue(klass: TypeOf<any>, instance: any): DependencyContainer {
    this._errorIfSealed()
    this._classes.set(klass, instance)
    return this
  }

  public get<T>(klass: TypeOf<T>): T {
    const value = this._classes.get(klass)
    if (typeof value === 'undefined') {
      throw new Error(`No dependency for '${klass.name}' provided!`)
    }
    return value
  }

  public getInstances(...klasses: Array<TypeOf<any>>): any[] {
    return klasses.map((k) => this.get(k))
  }

  public seal() {
    this._sealed = true
    return this
  }

  public dump(): Array<IDependency<any>> {
    const result: Array<IDependency<any>> = []
    const mapIterator = this._classes.entries()
    let currentItem = mapIterator.next()
    let klass
    let value
    while (!currentItem.done) {
      klass = currentItem.value[0]
      value = currentItem.value[1]
      result.push({provide: klass, useValue: value})

      currentItem = mapIterator.next()
    }
    return result
  }

  public clone() {
    const clone = new DependencyContainer()
    this.dump().forEach((d) => clone.provideValue(d.provide, d.useValue))
    return clone
  }

  public clear() {
    this._errorIfSealed()
    this._classes.clear()
  }

  private _errorIfSealed() {
    if (this._sealed) {
      throw new Error('DependencyContainer is sealed and cannot be mutated!')
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/helpers/dependency-container/dependency-container.ts